import { Contact } from '@contacts/interfaces/contact';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import { Order } from '@accounting/interfaces/order';
import { Message } from '@communications/interfaces/message';
const StdForm = () => import('@shared/components/forms/auto-form/std-form/std-form.vue');
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-contact-select-info',
  components: {
    'bpc-drawer-modal': DrawerModal,
    'bpc-std-form': StdForm,
  },
})
export default class ContactSelectInfo extends Vue {
  $refs: {
    stdMessageForm: any & {
      formModel: any;
      saveEntity(): void;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(Object) readonly element: Record<string, any>;

  public showMessageDrawer: boolean = false;
  public isSendingMessage: boolean = false;
  public keyMessage: number = 0;

  public onClick($event) {
    this.$emit('click', this.element);
  }

  /**
   * Send message functionality
   */

  public onCloseMessage() {
    this.showMessageDrawer = false;
  }

  public openMessageDrawer() {
    this.isSendingMessage = false;
    this.showMessageDrawer = true;
  }

  public onSendMessage() {
    this.isSendingMessage = true;
    this.$set(this.$refs.stdMessageForm.formModel, 'receivers', [this.element.id]);
    this.$refs.stdMessageForm.saveEntity();
  }

  public onSendedMessage() {
    this.showMessageDrawer = false;
    this.setEmptyMessageAttributesAfterSend();
    this.isSendingMessage = false;
  }

  public onErrorSendingMessage() {
    this.isSendingMessage = false;
  }

  setEmptyMessageAttributesAfterSend() {
    const newEntity = {} as Message;
    Object.keys(this.$refs.stdMessageForm.formModel).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'send_mail', false);
    this.$set(this.$refs.stdMessageForm, 'formModel', newEntity);
  }

  hasCommunicationsModuleActivated() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);
  }
}
